<template>
	<div class="main">
		<el-form :model="form" :rules="rules" ref="frmAdd" label-width="100px" class="demo-ruleForm">
			<el-form-item label="企业名称" prop="business">
				<el-input v-model="form.business"></el-input>
			</el-form-item>
			<el-form-item label="用户名" prop="username">
				<el-input v-model="form.username"></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="password">
				<el-input type="password" v-model="form.password"></el-input>
			</el-form-item>
			<el-form-item label="手机号" prop="phone">
				<el-input v-model="form.phone"></el-input>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {

				},
				rules: {
					areaName: [{
						required: true,
						message: '请输入区域名称',
						trigger: 'blur'
					}],
					create_time: [{
						required: true,
						message: '请输入创建时间',
						trigger: 'blur'
					}],
					gender: [{
						required: true,
						message: '请填写性别',
						trigger: 'blur'
					}],
					idcardno: [{
						required: true,
						message: '请输入身份证',
						trigger: 'blur'
					}],
					login_name: [{
						required: true,
						message: '请输入登录名',
						trigger: 'blur'
					}],
					nick_name: [{
						required: true,
						message: '请输入昵称',
						trigger: 'blur'
					}],
					pass_word: [{
						required: true,
						message: '请填写密码',
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						message: '请输入手机号码',
						trigger: 'blur'
					}]
				}
			}
		},
		
	}
</script>

<style scoped>
	
</style>
